import angular from 'angular';

angular
  .module('commonServices')
  .factory('userData', ['localStorageService', 'authService', userDataStore]);

function userDataStore(localStorageService, authService) {
  var userData = {};
  var storageKey = null;
  var defaultSettings = {
    relSections: JSON.stringify({
      relDashboard: true, // Dashboard
      '3fd70070-f8c0-45a4-b3f2-23afff37061f': true, // Identificatie
    }),
  };

  /* eslint-disable */
  var hashCode = function(s) {
    return s.split('').reduce(function(a, b) {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  };
  /* eslint-enable */

  var load = function() {
    if (!storageKey) storageKey = 'UserData_' + hashCode(authService.getClaims().Sid);
    var key = storageKey;
    userData = key ? localStorageService.get(key) || angular.copy(defaultSettings) : {};
    return !!key;
  };
  var save = function() {
    var key = storageKey;
    if (key) return localStorageService.set(key, userData);
    return false;
  };

  var setValue = function(key, value) {
    userData[key] = JSON.stringify(value);
  };

  var getValue = function(key, fallback) {
    if (!userData[key]) return fallback;
    return JSON.parse(userData[key]);
  };

  //First argument is the key
  //Second argument is a function witch receives the old value and must return the new value
  var updateValue = function(key, fnc) {
    setValue(key, fnc(getValue(key)));
  };

  var removeValue = function(key) {
    delete userData[key];
  };
  authService.addOnLogOut(function() {
    storageKey = null;
    userData = null;
  });

  return {
    //Override value, returns true if successfull
    set: function(key, value) {
      if (!load()) return false;
      setValue(key, value);
      return save();
    },
    //Retrieve value, returns fallback if not logged in
    get: function(key, fallback) {
      if (!load()) return fallback;
      return getValue(key, fallback);
    },
    //Update value using an update function, returns true if successfull
    //The function has 1 parameter: the current value
    //It should return the new value
    update: function(key, fnc) {
      if (!load()) return false;
      updateValue(key, fnc);
      return save();
    },
    //Remove a value, returns true if successfull
    remove: function(key) {
      if (!load()) return false;
      removeValue(key);
      return save();
    },
  };
}
